import { useNavigate } from 'react-router'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="content" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '64px', fontWeight: 800, color: 'var(--border)' }}>404</div>
        <div style={{ color: 'var(--muted)', marginTop: '8px' }}>Página no encontrada</div>
        <button className="btn btn-secondary" style={{ marginTop: '16px' }} onClick={() => navigate('/')}>
          ← Volver al dashboard
        </button>
      </div>
    </div>
  )
}
